module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"by":"by","controls":{"undo":"Undo","redo":"Redo","goBack":"Go back","saveChanges":"Save changes","noChanges":"No changes to save"}},"cs":{"by":"od","controls":{"undo":"Krok zpět","redo":"Krok vpřed","goBack":"Zpět","saveChanges":"Uložit změny","noChanges":"Žádné změny nebyly provedeny"}}}')
  delete Component.options._Ctor
}
